<script>
    export default {
        name: 'NormalCheckBox',
        props: {
            // 是否选中
            checked: {
                default: false,
                required: false
            },
            // 是否禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
            // radio的name值
            label: {
                default: '',
                require: false
            },
            // radio的value值
            value: {
                default: '',
                require: false
            }
        },
        data () {
            return {
                selfChecked: this.checked
            };
        },
        model: {
            prop: 'checked',
            event: 'check'
        },
        computed: {
            isChecked: {
                get () {
                    return  this.selfChecked;
                },
                set (val) {
                    this.selfChecked = val;
                    this.$emit('check', val);
                }
            }
        }
    };
</script>
<template>
    <div class="normal-radiobox" :class="{
        disabled: disabled
    }">
        <input type="radio"
               :name="label"
               :value="value"
               :disabled="disabled"
               v-model="isChecked"
               class="normal-radio"
        >
        <i class="normal-check-icon"></i>
    </div>
</template>
<style scoped lang="less">
    @import "../../assets/less/widgets-var";

    .normal-radiobox {
        font-size: 0;
        /*下面这里先注释掉，不确定原因为什么又这个，如果因为这个影响到了，可以先与谢福成联系*/
        /*.px2rem(height, 90);
        .px2rem(line-height, 92);*/
        &.disabled{
            .normal-check-icon:before{
                background-color: @otherDisabledBgClr;
            }
        }
    }

    .normal-radio {
        position: absolute;
        left: -99999rem;

        &:checked + .normal-check-icon:before {
            content: '\E695';
            background-color: @primaryBg;
            color: @whiteBg;
            border: none;
        }
    }

    .normal-check-icon {
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        font: normal normal normal 14px/1 "cmsicon";
        font-size: inherit;
        text-rendering: auto;
        .px2rem(width, 38);
        .px2rem(height, 38);

        &:before {
            box-sizing: border-box;
            content: '';
            display: block;
            border: 1px solid @otherBtnBorderNoteClr;
            border-radius: 50%;
            text-align: center;
            .px2rem(width, 38);
            .px2rem(font-size, 26);
            .px2rem(height, 38);
            .px2rem(line-height, 42);

        }
    }
</style>
